import { AMOUNT_OF_IMAGES, SPEED, AMOUNT, EXAM } from './config.js';

export const DOMstrings = {
    instruction: document.getElementById('instr'),
    question: document.querySelector('.question'),
    answers: document.querySelector('.answers'),
    stopBtn: document.getElementById('btn-stop'),
    startBtn: document.getElementById('btn-start'),
    speed: document.getElementById('speed'),
    speedSlider: document.getElementById('speedSlider'),
    amount: document.getElementById('amount'),
    amountSlider: document.getElementById('amountSlider'),
    exam: document.getElementById('exam'),
    examSlider: document.getElementById('examSlider'),
    answer: document.getElementById('answer'),
    answersBtn: document.querySelector('.answers__btns'),
    yes: document.getElementById('yes'),
    no: document.getElementById('no'),
    statistics: document.querySelector('.statistics'),
    restart: document.querySelector('.btn-restart'),
    nut: document.getElementById('btn-settings'),
    settings: document.getElementById('popup'),
};

const getSpeed = () => parseFloat(DOMstrings.speed.value) * 1000;

export const startShow = function () {
    DOMstrings.startBtn.style.display = 'none';
    DOMstrings.instruction.style.display = 'block';
};

export const instructionAnimateTop = () =>
    (DOMstrings.instruction.style.top = `${35}px`);

let i = 0;
let timeoutID;
export const render = function (srces, quiz, startQuiz) {
    DOMstrings.stopBtn.disabled = false;
    DOMstrings.question.style.display = 'block';

    if (i < srces.length) {
        DOMstrings.question.firstElementChild.src = srces[i].src;
        i++;
        timeoutID = setTimeout(
            () => render(srces, quiz, startQuiz),
            getSpeed()
        );
    } else if (i == srces.length) {
        startQuiz();
    }
};

let r = 0;
export const showQuiz = function (quizImage, stat) {
    resetMark();
    r++;
    DOMstrings.instruction.textContent = `Эта картинка была показана? ${r}/${stat.amountOfQuestions}`;
    DOMstrings.question.style.display = 'none';
    DOMstrings.answers.style.display = 'block';
    DOMstrings.answersBtn.style.display = 'block';

    if (DOMstrings.answers.querySelector('.answers img'))
        DOMstrings.answers.removeChild(
            DOMstrings.answers.querySelector('.answers img')
        );

    DOMstrings.answers.prepend(quizImage);
};

export const markAnswer = (item, isCorrect) => {
    if (isCorrect) {
        item.style.backgroundColor = 'green';
    }
    if (!isCorrect) {
        item.style.backgroundColor = 'red';
    }
};

const resetMark = () => {
    DOMstrings.yes.style.backgroundColor = 'gray';
    DOMstrings.no.style.backgroundColor = 'gray';
};

export const restart = function () {
    DOMstrings.stopBtn.disabled = true;
    clearTimeout(timeoutID);
    if (DOMstrings.answers.querySelector('.answers img'))
        DOMstrings.answers.removeChild(
            DOMstrings.answers.querySelector('.answers img')
        );

    DOMstrings.yes.style.backgroundColor = 'gray';
    DOMstrings.no.style.backgroundColor = 'gray';

    DOMstrings.question.style.display = 'none';
    DOMstrings.answers.style.display = 'none';
    DOMstrings.instruction.textContent = 'Просмотрите изображения';
    DOMstrings.instruction.style.display = 'none';
    DOMstrings.instruction.style.top = `50%`;
    DOMstrings.startBtn.style.display = 'block';

    DOMstrings.statistics.innerHTML = '';

    i = 0;
    r = 0;
};

export const showStat = function (stat) {
    DOMstrings.answers.style.display = 'none';
    DOMstrings.answersBtn.style.display = 'none';
    DOMstrings.instruction.textContent = 'Статистика';

    const html = `
        <p>Время показа каждой картинки: ${getSpeed() / 1000} сек</p>
        <p>Количество выводимых картинок: ${stat.customAmountOfItems}</p>
        <p>Количество проверочных картинок: ${stat.amountOfQuestions}</p>
        <p>Количество верно определенных картинок: ${
            stat.userAnswers.correct
        }</p>
        <button class="btn-restart" id="btn-stop">
            Хочу улучшить мою фотографическую память
        </button>
    `;

    DOMstrings.statistics.insertAdjacentHTML('afterbegin', html);
    setTimeout(
        () =>
            document
                .querySelector('.btn-restart')
                .classList.add('btn-restart-active'),
        1000
    );
};

/* Setting validation */
export const speedValidation = () => {
    const interval = parseFloat(DOMstrings.speed.value) * 1000;
    if (interval < SPEED.min * 1000) DOMstrings.speed.value = SPEED.min + '';
    if (interval > SPEED.max * 1000) DOMstrings.speed.value = SPEED.max + '';
};

export const amountValidation = () => {
    const amount = +DOMstrings.amount.value;

    if (amount < AMOUNT.min) DOMstrings.amount.value = AMOUNT.min + '';

    if (amount > AMOUNT_OF_IMAGES - 1)
        DOMstrings.amount.value = AMOUNT_OF_IMAGES - 1 + '';

    DOMstrings.exam.max = DOMstrings.amount.value;
    DOMstrings.examSlider.max = DOMstrings.amountSlider.value;

    examValidation();
};

export const examValidation = () => {
    const exam = +DOMstrings.exam.value;

    if (exam < EXAM.min) DOMstrings.exam.value = EXAM.min;

    if (exam > DOMstrings.amount.value) {
        DOMstrings.exam.max = DOMstrings.amount.value;
        DOMstrings.exam.value = DOMstrings.amount.value;
    }

    if (exam > AMOUNT_OF_IMAGES - DOMstrings.amount.value) {
        DOMstrings.exam.max = AMOUNT_OF_IMAGES - DOMstrings.amount.value;
        DOMstrings.exam.value = AMOUNT_OF_IMAGES - DOMstrings.amount.value;
        DOMstrings.examSlider.max = AMOUNT_OF_IMAGES - DOMstrings.amount.value;
        DOMstrings.examSlider.value =
            AMOUNT_OF_IMAGES - DOMstrings.amount.value;
    }
};
/* ----- */

/* Settings pop-up controller */
export const openSettings = () => {
    DOMstrings.nut.classList.add('active');
    DOMstrings.settings.classList.add('show');
};

export const closeSettings = (e) => {
    if (
        e.target === DOMstrings.settings ||
        e.key === 'Escape' ||
        e.key === 'Enter'
    ) {
        DOMstrings.nut.classList.remove('active');
        DOMstrings.settings.classList.remove('show');
    }
};
/* ----- */
